export default __webpack_public_path__ + "static/media/q12_step5.56abd60d.png";